<template>
  <div class="tab-container">
    <div
      v-for="item in tabList"
      :key="item.key"
      :class="['item', value === item.key ? 'active' : '']"
      @click="handleChange(item.key)"
    >
      {{ item.label }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      activeIndex: 1,
      tabList: [
        {
          label: "一般模式",
          key: 1
        },
        {
          label: "公会战模式",
          key: 2
        }
      ]
    };
  },
  methods: {
    handleChange(key) {
      this.$emit("change", key);
    }
  }
};
</script>
<style lang="less" scoped>
.tab-container {
  display: flex;
  padding: 2px;
  background-color: rgba(166, 171, 183, 0.2);
  border-radius: 4px;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 147px;
    height: 32px;
    border-radius: 4px;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    &.active {
      background-color: #5e646e;
      color: #fff;
    }
  }
}
</style>
